<template>
  <InsurerPage :insurerSlug="$route.params.token">
    <template v-slot="{ insurer }">
      <v-app>
        <v-container class="mt-12 text-center px-8" style="max-width: 500px">
          <div class="mx-auto">
            <v-avatar color="green lighten-4" size="100">
              <v-icon color="green" size="70">mdi-check</v-icon>
            </v-avatar>
            <h1 class="text-h2 mt-4">Sucesso</h1>

            <div class="mt-9 grey--text">
              <span class="grey--text text--darken-1">
                As informações e os documentos que acabou de submeter
                encontram-se em análise.
                <span v-if="$route.query.process">
                  Anote o número temporário gerado:
                  <b>{{ $route.query.process }}</b>
                </span>
              </span>
              <br />
              <br />
              Pode acompanhar o estado do seu sinistro e consultar todas as
              actualizações ao processo, a qualquer momento, através do link
              abaixo:
              <br />
              <br />
              <a
                href="#"
                class="font-streight-bold"
                :style="{
                  color: insurer.color,
                }"
              >
                Acompanhar processo
                <v-icon size="15" :color="insurer.color"
                  >mdi-open-in-new</v-icon
                >
              </a>
              <br /><br />
              Caso sejam necessárias informações adicionais, entraremos em
              contacto consigo. Agradecemos a sua colaboração.
            </div>
          </div>
        </v-container>
      </v-app>
    </template>
  </InsurerPage>
</template>

<script>
import InsurerPage from "@/components/insurers/InsurerPage";

export default {
  mixins: [],

  components: {
    InsurerPage,
  },

  props: {},

  data() {
    return {};
  },

  methods: {},

  computed: {},
};
</script>
